module.exports = __webpack_public_path__ + "img/banner1.8db3b485.png";